import React from 'react';

import LazyLoadedImage from 'common/LazyLoadedImage';

const CapterraPixelSrc =
  'https://ct.capterra.com/capterra_tracker.gif?vid=2112643&vkey=028ee0fe77fb0156fff10e1910d7c675';

export default function CapterraPixel() {
  return <LazyLoadedImage alt="" src={CapterraPixelSrc} />;
}
